import configData from "../config.json";

async function getViewerByIntervention(encoding)
{
    return await fetch(configData.SERVER_URL + "/Viewer?" + encoding)
        .then((res) => res.json())
        .catch((err) => console.error(err));
}

export { getViewerByIntervention }